export default {"src":"/_next/static/media/HorschTiger.64ca9026.svg","height":70,"width":178};